export const InteractionStateChooserPluginSymbol = Symbol.for('InteractionStateChooserPlugin')

// used to choose whether remote or local state should be used after the remote state loaded
// it is used especially for questions where the initial state (e.g. random order) is saved for
// several question types
export interface InteractionStateChooserPlugin<TState> {
  choose(local: TState, remote: TState): 'use-local' | 'use-remote'
}

export const InteractionStateChooserFactorySymbol = Symbol.for("InteractionStateChooserFactory");
export type InteractionStateChooserFactory<TState> =
      (type: string) => InteractionStateChooserPlugin<TState>
